import { render, staticRenderFns } from "./FilterOptionTigerC.vue?vue&type=template&id=2d44ad4c&scoped=true&"
import script from "./FilterOptionTigerC.vue?vue&type=script&lang=js&"
export * from "./FilterOptionTigerC.vue?vue&type=script&lang=js&"
import style0 from "./FilterOptionTigerC.vue?vue&type=style&index=0&id=2d44ad4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44ad4c",
  null
  
)

export default component.exports